export default __webpack_public_path__ + "static/facilities-img1-4d2772b577d70369a44360b2f267387b.png";